<template>
  <div>
    <ContentPage headerText="About Us">
      <p>
        EcoSpark Electrical are a Norfolk-based electrical and renewable energy 
        company dedicated to providing honest advice, quality workmanship, and 
        exceptional customer service.
      </p>
      <p>
        We believe every customer deserves a contractor they can trust. 
        That's why we take pride in delivering reliable electrical services, 
        solar PV installations, battery storage systems, and energy-efficient 
        solutions tailored to the needs of each home and business we work with.
      </p>
      <p>
        From replacing a consumer unit and carrying out electrical inspections 
        to designing and installing complete solar and battery storage systems, 
        we approach every project with the same care, attention to detail, and 
        commitment to excellence. We treat every job as if it were our own property, 
        ensuring the highest standards of safety, workmanship, and customer 
        satisfaction.
      </p>
      <p>
        As NAPIT-registered electricians, TrustMark-approved professionals, and 
        MCS-accredited installers, our customers can have complete confidence that 
        all work is carried out to recognised industry standards and backed by 
        trusted accreditation schemes. We are committed to staying up to date with 
        the latest technologies and regulations, helping our customers benefit from 
        safe, efficient, and future-ready electrical and renewable energy solutions.
      </p>
      <p>
        Our goal isn't simply to complete a job, it's to build long-term relationships 
        based on trust, reliability, and outstanding service.
      </p>
      <p>
        Whether you're looking for a trusted electrician, considering solar panels 
        and battery storage, or planning improvements to your property's energy 
        efficiency, we're here to provide expert guidance and professional installation 
        every step of the way.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
        <!--
          <div>
            <h2>Meet our Team</h2>

            <div class="row card-container">
              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/steven.jpg"
                    alt="Steven Jackson wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Steven Jackson</h5>
                    <p class="card-subtitle mb-2">Director</p>
                    <p class="card-text">
                      Steven has years of experience in the automotive industry
                      and brings a wealth of knowledge and expertise to our
                      team. Steven handles the day to day running of the
                      workshop and will be in the office to greet you with a big
                      smile.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/reece.jpg"
                    alt="Reece wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Reece</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Reece is our hardworking apprentice at EcoSpark Electrical Ltd, eager to learn and grow within the automotive industry. He brings enthusiasm and a positive attitude to every task, always keen to develop new skills. Under the guidance of the team, Reece has quickly become a valuable part of the workshop.
                    </p>
                  </div>
                </div>
              </div>
            

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/hanna.jpg"
                    alt="Hanna wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Hanna</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Hanna is our welcoming voice and organised mind behind our front desk. Hanna plays a key role in making sure customers receive a smooth and hassle-free experience, from arranging bookings to keeping everyone updated throughout their visit. Her friendly attitude, attention to detail, and commitment to great customer service help keep the garage running efficiently every day.
                    </p>
                  </div>
                </div>
              </div>
            
              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/warren.jpg"
                    alt="Warren wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Warren</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Warren is a highly experienced and reliable member of the EcoSpark Electrical Ltd team, known for his strong work ethic and attention to detail. He approaches each task with professionalism and a commitment to excellence. Whether tackling diagnostics or complex repairs, Warren ensures every job is done right the first time.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/georgia.jpg"
                    alt="Georgia wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Georgia</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Georgia is the friendly and efficient face of the EcoSpark Electrical Ltd reception, keeping everything running smoothly behind the scenes. She handles bookings, enquiries, and customer support with professionalism and a smile. Always ready to help, Georgia ensures every customer has a great experience from start to finish.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/danny.jpg"
                    alt="Danny wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Danny</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Danny is a highly skilled technician at EcoSpark Electrical Ltd with over 10 years of hands-on experience in vehicle diagnostics, MOT testing and repairs. Known for his precision, he’s committed to getting customers back on the road safely and efficiently. Whether it’s routine maintenance, MOT testing or complex engine work, Danny delivers reliable results every time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        !-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'about-us',
  components: {
    ContentPage
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 68px;
  padding-bottom: 0px;
}

.card-container {
  row-gap: 30px;
}

.card {
  height: 100%;

  border: 0;
  background-color: #f5f5f5;
  box-shadow: $shadow;

  &-body {
    border-right: 20px solid $clr-theme-red;
  }

  &-title {
    color: $clr-theme-red;
    font-weight: 700;
  }

  &-subtitle {
    font-size: 18px;
  }

  &-text {
    font-weight: 400;
    text-align: justify;
  }

  &-img-top {
    height: 300px;
    object-fit: cover;
  }
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;

  > * {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  font-weight: 500;

  strong {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue